import { createContext } from 'react';
import { AppFlags } from '../client/config';

const FlagsContext = createContext<AppFlags>({
  enableDonateToTeam: false,
  enableOtgAuction: false,
  enableOtgImmersiveGiving: false,
  enableOtgVideoChat: false,
  useCutterForSocialSharing: false,
  virtualFitnessEventsDebugFeatures: false,
  virtualFitnessEventsPreview: false,
  useLeaderboarFundraisersList: false,
});

export default FlagsContext;
FlagsContext.displayName = 'FlagsContext';

export const FlagsProvider = FlagsContext.Provider;
export const FlagsConsumer = FlagsContext.Consumer;
